const template = require('./investment_account_show.html.slim');
const controller = require('./investment_account_show_controller');

angular.module('wbComponents').directive('investmentAccountShow', () => ({
  restrict: 'E',
  replace: true,
  controller,
  templateUrl: template,
  controllerAs: 'ctrl'
}));

